export enum ResourcePermanency {
  IntegralTime = "IntegralTime",
  OnlyAssembly = "OnlyAssembly",
  OnlyDisassembly = "OnlyDisassembly",
}
